<div class="pli">
  <!-- 2-column responsive grid; each cell has its own label + input.
       Iterates `visibleLanguages` so the editor-wide "show only X"
       filter (set by clicking a hero language card) takes effect here.
       Per-locale fanout button (`↗`) lives next to the language tag —
       click copies that locale's value to every other active locale. -->
  <div
    class="pli__grid"
    [class.pli__grid--single]="visibleLanguages().length === 1"
    [class.pli__grid--stacked]="type() === 'textarea'"
  >
    @for (l of visibleLanguages(); track trackByLocale($index, l)) {
    <div class="pli__cell">
      <div class="pli__head">
        <span
          class="pli__dot"
          [class.pli__dot--on]="hasValue(l.locale)"
          aria-hidden="true"
        ></span>
        <span class="pli__tag" [title]="l.label">{{ l.shortCode }}</span>
        @if (canFanout(l.locale)) {
        <button
          type="button"
          class="pli__fanout"
          [title]="fanoutTooltip(l.locale)"
          [attr.aria-label]="fanoutTooltip(l.locale)"
          [disabled]="disabled()"
          (click)="copyFromLocaleToOthers(l.locale)"
        >
          <mat-icon aria-hidden="true">east</mat-icon>
        </button>
        }
      </div>

      @if (type() === 'textarea') {
      <textarea
        class="pli__input pli__input--textarea"
        [class.pli__input--error]="isMissing(l.locale)"
        [attr.rows]="rows()"
        [value]="readValue(l.locale)"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [attr.aria-invalid]="isMissing(l.locale) ? 'true' : null"
        (input)="writeValue(l.locale, $any($event.target).value)"
      ></textarea>
      } @else {
      <input
        type="text"
        class="pli__input"
        [class.pli__input--error]="isMissing(l.locale)"
        [value]="readValue(l.locale)"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [attr.aria-invalid]="isMissing(l.locale) ? 'true' : null"
        (input)="writeValue(l.locale, $any($event.target).value)"
      />
      }
    </div>
    }
  </div>

  @if (tip()) {
  <p class="pli__tip">
    <mat-icon aria-hidden="true">lightbulb</mat-icon>
    {{ tip() }}
  </p>
  }
</div>
